<template>
  <v-app class="app" :class="{ 'header-custom': shouldUseCustomHeader && !$vuetify.breakpoint.smAndDown , 'white-header': !shouldUseCustomHeader, 'mobile-toolbar-header':  shouldUseCustomHeader && $vuetify.breakpoint.smAndDown }">
    <v-layout v-if="isLoading || !getStore" align-center justify-center row wrap fill-height class="full-size">
      <v-flex xs12>
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <div class="mt-3 title">Loading app...</div>
      </v-flex>
    </v-layout>
    <template v-else-if="$route.name !== 'stripe-handler'">
      <v-content class="app" :class="{ 'header-custom': shouldUseCustomHeader && !$vuetify.breakpoint.smAndDown, 'white-header': !shouldUseCustomHeader,  'mobile-toolbar-header':  shouldUseCustomHeader && $vuetify.breakpoint.smAndDown }">
        <SnackBar />

        <HeaderBar v-if="!shouldUseCustomHeader"/>
        <HeaderBarCustom v-if="shouldUseCustomHeader"/>

        <template v-if="$route.name === 'store' || $route.name === 'menu-selection'">
          <store-sub-header />
        </template>
        <div v-else-if="$route.name === 'group'">
          <group-sub-header />
        </div>

        <router-view />

        <!-- DEV-11345: mounted only while open -- always mounting it downloaded the 287 KB
             qr-scanner chunk (camera QR decoder) on every page load for every guest. -->
        <QRScanner v-if="getQrScannerDialog" />

        <v-dialog
          style="z-index: 999;"
          v-model="getWeChatDialog"
          transition="slide-y-reverse-transition"
        >
          <v-card>
            <v-card-title
              align-self-center
              justify-center
              class="headline grey lighten-2"
              primary-title
            >
              <v-flex>
                {{ $vuetify.t('$vuetify.weChat.title') }}
              </v-flex>
            </v-card-title>

            <v-divider />

            <v-card-actions>
              <ManualTableNo @result="handleQRInput" />
            </v-card-actions>

            <v-card-actions style="padding-top: 0px !important">
              <v-btn color="secondary" text @click="closeWeChatDialog()" style="width: 220px; margin: auto">
                {{ $vuetify.t('$vuetify.cart.closeModal') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-content>

      <template v-if="!shouldUseCustomHeader && getStore && ($route.name === 'store' || $route.name === 'menu-selection')">
        <store-footer />
      </template>

      <template v-if="shouldUseCustomHeader && getStore && ($route.name === 'store' || $route.name === 'menu-selection')">
        <store-footer-custom />
      </template>

      <menu-item-config />
      <coupon-config />
      <rewards-options-config />

      <login-dialog v-if="!isLoggedIn" />
      <DeliveryDialog />
      <PickupDeliveryEditDialog />
      <iFrameDialog />
      <successful-order-dialog />
      <ContactTracingDialog />
      <order-bonus />
      <error-message-dialog />
      <group-order-join-dialog />

      <!-- Shared cart: joined via invite link -->
      <v-dialog v-model="showSharedCartJoinedDialog" max-width="360" persistent>
        <v-card style="border-radius: 20px; padding: 28px 24px 20px; text-align: center;">
          <v-icon size="48" color="success" style="margin-bottom: 12px;">check_circle</v-icon>
          <div style="font-size: 18px; font-weight: 700; margin-bottom: 8px;">{{ $vuetify.t('$vuetify.sharedCart.joinedTitle') }}</div>
          <div style="font-size: 13px; color: #888; margin-bottom: 20px;">{{ $vuetify.t('$vuetify.sharedCart.joinedBody') }}</div>
          <v-btn color="primary" block depressed style="border-radius: 25px;" @click="showSharedCartJoinedDialog = false">{{ $vuetify.t('$vuetify.common.ok') }}</v-btn>
        </v-card>
      </v-dialog>

      <!-- Shared cart: session completed (someone else paid) -->
      <v-dialog v-model="showSharedCartCompletedDialog" max-width="360" persistent>
        <v-card style="border-radius: 20px; padding: 28px 24px 20px; text-align: center;">
          <v-icon size="48" color="success" style="margin-bottom: 12px;">check_circle</v-icon>
          <div style="font-size: 18px; font-weight: 700; margin-bottom: 8px;">{{ $vuetify.t('$vuetify.sharedCart.completedTitle') }}</div>
          <div style="font-size: 13px; color: #888; margin-bottom: 20px;">{{ $vuetify.t('$vuetify.sharedCart.completedBody') }}</div>
          <v-btn color="primary" block depressed style="border-radius: 25px;" @click="dismissSharedCartCompletedDialog">{{ $vuetify.t('$vuetify.common.ok') }}</v-btn>
        </v-card>
      </v-dialog>

      <!-- Shared cart: session closed, bill sent to POS terminal (not yet actually paid) -->
      <v-dialog v-model="showSharedCartBillAtPosDialog" max-width="360" persistent>
        <v-card style="border-radius: 20px; padding: 28px 24px 20px; text-align: center;">
          <v-icon size="48" color="primary" style="margin-bottom: 12px;">point_of_sale</v-icon>
          <div style="font-size: 18px; font-weight: 700; margin-bottom: 8px;">{{ $vuetify.t('$vuetify.sharedCart.billAtPosTitle') }}</div>
          <div style="font-size: 13px; color: #888; margin-bottom: 20px;">{{ $vuetify.t('$vuetify.sharedCart.billAtPosBody') }}</div>
          <v-btn color="primary" block depressed style="border-radius: 25px;" @click="showSharedCartBillAtPosDialog = false">{{ $vuetify.t('$vuetify.common.ok') }}</v-btn>
        </v-card>
      </v-dialog>

      <!-- Shared cart: session cancelled -->
      <v-dialog v-model="showSharedCartCancelledDialog" max-width="360" persistent>
        <v-card style="border-radius: 20px; padding: 28px 24px 20px; text-align: center;">
          <v-icon size="48" color="error" style="margin-bottom: 12px;">cancel</v-icon>
          <div style="font-size: 18px; font-weight: 700; margin-bottom: 8px;">{{ $vuetify.t('$vuetify.sharedCart.cancelledTitle') }}</div>
          <div style="font-size: 13px; color: #888; margin-bottom: 20px;">{{ $vuetify.t('$vuetify.sharedCart.cancelledBody') }}</div>
          <v-btn color="primary" block depressed style="border-radius: 25px;" @click="dismissSharedCartCancelledDialog">{{ $vuetify.t('$vuetify.common.ok') }}</v-btn>
        </v-card>
      </v-dialog>

      <!-- Group order cancelled by host dialog -->
      <v-dialog v-model="showCancelledByHostDialog" max-width="360">
        <v-card style="border-radius: 20px; padding: 28px 24px 20px; text-align: center;">
          <v-icon size="48" color="error" style="margin-bottom: 12px;">cancel</v-icon>
          <div style="font-size: 18px; font-weight: 700; margin-bottom: 8px;">{{ $vuetify.t('$vuetify.groupOrder.dialogCancelledTitle') }}</div>
          <div style="font-size: 13px; color: #888; margin-bottom: 20px;">{{ $vuetify.t('$vuetify.groupOrder.dialogCancelledBody') }}</div>
          <v-btn color="primary" block depressed style="border-radius: 25px;" @click="dismissCancelledDialog">{{ $vuetify.t('$vuetify.common.ok') }}</v-btn>
        </v-card>
      </v-dialog>

      <!-- Group order paid (participant) dialog -->
      <v-dialog v-model="showGroupOrderPaidDialog" max-width="360">
        <v-card style="border-radius: 20px; padding: 28px 24px 20px; text-align: center;">
          <v-icon size="48" color="success" style="margin-bottom: 12px;">check_circle</v-icon>
          <div style="font-size: 18px; font-weight: 700; margin-bottom: 8px;">{{ $vuetify.t('$vuetify.groupOrder.dialogPaidTitle') }}</div>
          <div style="font-size: 13px; color: #888; margin-bottom: 20px;">{{ $vuetify.t('$vuetify.groupOrder.dialogPaidBody') }}</div>
          <v-btn color="primary" block depressed style="border-radius: 25px;" @click="dismissGroupOrderPaidDialog">{{ $vuetify.t('$vuetify.common.ok') }}</v-btn>
        </v-card>
      </v-dialog>

      <!-- Removed from group order dialog -->
      <v-dialog v-model="showRemovedFromGroupDialog" max-width="360">
        <v-card style="border-radius: 20px; padding: 28px 24px 20px; text-align: center;">
          <v-icon size="48" color="error" style="margin-bottom: 12px;">remove_circle</v-icon>
          <div style="font-size: 18px; font-weight: 700; margin-bottom: 8px;">{{ $vuetify.t('$vuetify.groupOrder.dialogRemovedTitle') }}</div>
          <div style="font-size: 13px; color: #888; margin-bottom: 20px;">{{ $vuetify.t('$vuetify.groupOrder.dialogRemovedBody') }}</div>
          <v-btn color="primary" block depressed style="border-radius: 25px;" @click="dismissRemovedDialog">{{ $vuetify.t('$vuetify.common.ok') }}</v-btn>
        </v-card>
      </v-dialog>

      <!-- Left group order dialog -->
      <v-dialog v-model="showLeftGroupDialog" max-width="360">
        <v-card style="border-radius: 20px; padding: 28px 24px 20px; text-align: center;">
          <v-icon size="48" color="primary" style="margin-bottom: 12px;">exit_to_app</v-icon>
          <div style="font-size: 18px; font-weight: 700; margin-bottom: 8px;">
            {{ $vuetify.t('$vuetify.groupOrder.dialogLeftTitle', [$store.state.groupOrder.leftGroupName || $vuetify.t('$vuetify.groupOrder.title')]) }}
          </div>
          <div style="font-size: 13px; color: #888; margin-bottom: 20px;">{{ $vuetify.t('$vuetify.groupOrder.dialogLeftBody') }}</div>
          <v-btn color="primary" block depressed style="border-radius: 25px;" @click="showLeftGroupDialog = false; $store.commit('groupOrder/SET_LEFT', false)">{{ $vuetify.t('$vuetify.common.ok') }}</v-btn>
        </v-card>
      </v-dialog>

      <!-- Group order recovered dialog -->
      <v-dialog v-model="showRecoveredGroupDialog" max-width="360" persistent>
        <v-card style="border-radius: 20px; padding: 28px 24px 20px; text-align: center;">
          <v-icon size="48" color="primary" style="margin-bottom: 12px;">group</v-icon>
          <div style="font-size: 18px; font-weight: 700; margin-bottom: 8px;">{{ $vuetify.t('$vuetify.groupOrder.dialogRecoveredTitle') }}</div>
          <div style="font-size: 13px; color: #888; margin-bottom: 4px;">{{ recoveredGroupName }}</div>
          <div style="font-size: 12px; color: #aaa; margin-bottom: 20px;">{{ recoveredGroupRole }}</div>
          <v-btn color="primary" block depressed style="border-radius: 25px;" @click="showRecoveredGroupDialog = false">{{ $vuetify.t('$vuetify.groupOrder.dialogRecoveredBtn') }}</v-btn>
        </v-card>
      </v-dialog>

      <!-- Group order settings changed by host dialog -->
      <v-dialog v-model="showGroupChangedDialog" max-width="380">
        <v-card style="border-radius: 20px; padding: 28px 28px 20px; text-align: center;">
          <v-icon size="48" color="primary" style="margin-bottom: 12px;">update</v-icon>
          <div style="font-size: 18px; font-weight: 700; margin-bottom: 12px;">{{ $vuetify.t('$vuetify.groupOrder.dialogChangedTitle') }}</div>
          <div v-if="groupChangedNotification" style="font-size: 14px; color: #555; margin-bottom: 20px; line-height: 1.6;">
            <div v-if="groupChangedNotification.oldOrderType !== groupChangedNotification.newOrderType" style="margin-bottom: 6px;">
              <span v-if="groupChangedNotification.newOrderType === 'DELIVERY'">
                {{ $vuetify.t('$vuetify.groupOrder.dialogChangedToDelivery') }}
                <span v-if="groupChangedNotification.newDeliveryAddress" style="display: block; margin-top: 4px; color: #888;">{{ formatGroupOrderAddress(groupChangedNotification.newDeliveryAddress) }}</span>
              </span>
              <span v-else>
                {{ $vuetify.t('$vuetify.groupOrder.dialogChangedToPickup') }}
              </span>
            </div>
            <div v-if="groupChangedNotification.oldScheduledTime !== groupChangedNotification.newScheduledTime">
              <div v-if="groupChangedNotification.oldScheduledTime && groupChangedNotification.newScheduledTime">
                <div style="color: #888; font-size: 12px; margin-bottom: 2px;">{{ $vuetify.t('$vuetify.groupOrder.timeChangedLabel') }}</div>
                <div><span style="text-decoration: line-through; color: #aaa;">{{ formatGroupOrderTime(groupChangedNotification.oldScheduledTime) }}</span> → {{ formatGroupOrderTime(groupChangedNotification.newScheduledTime) }}</div>
              </div>
              <div v-else-if="groupChangedNotification.newScheduledTime">
                <div style="color: #888; font-size: 12px; margin-bottom: 2px;">{{ $vuetify.t('$vuetify.groupOrder.timeChangedToLabel') }}</div>
                <div>{{ formatGroupOrderTime(groupChangedNotification.newScheduledTime) }}</div>
              </div>
              <div v-else-if="groupChangedNotification.oldScheduledTime">
                <div style="color: #888; font-size: 12px; margin-bottom: 2px;">{{ $vuetify.t('$vuetify.groupOrder.timeChangedToLabel') }}</div>
                <div>{{ $vuetify.t('$vuetify.groupOrder.asap') }}</div>
              </div>
            </div>
          </div>
          <v-btn color="primary" block depressed style="border-radius: 25px;" @click="dismissGroupChangedDialog">{{ $vuetify.t('$vuetify.common.ok') }}</v-btn>
        </v-card>
      </v-dialog>

      <v-dialog v-model="isLocationDisabled" max-width="290">
        <v-card v-if="isLocationDisabled">
          <v-card-title class="headline">
            {{ $vuetify.t('$vuetify.errors.location.locationDisabledTitle') }}
          </v-card-title>

          <v-card-text>
            {{ $vuetify.t('$vuetify.errors.location.locationDescription') }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="closeInStoreDlg('location')">
              {{ $vuetify.t('$vuetify.errors.location.locationBtn') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showInStoreDlg" max-width="290">
        <v-card v-if="showInStoreDlg">
          <v-card-title class="headline">
            {{ $vuetify.t('$vuetify.errors.location.inStoreTitle') }}
          </v-card-title>

          <v-card-text>
            {{ $vuetify.t('$vuetify.errors.location.inStoreDescription') }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeInStoreDlg('inStore')">
              {{ $vuetify.t('$vuetify.errors.location.inStoreBtn') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <router-view v-else />
  </v-app>
</template>

<script>
import get from 'lodash/get';
import debounce from 'lodash/debounce';

import { findErrorMessage, getUrlParameter, isNullOrEmpty, APP_SPECIFIC_KEYS, formatGroupOrderAddress } from "./services/util.service"
import { isScheduledTimeWatcherSuppressed } from "./services/group-order-switch.service"
import { mapGetters, mapMutations, mapActions } from 'vuex'


import HeaderBar from '@/components/HeaderBar.vue'
import HeaderBarCustom from '@/components/HeaderBarCustom.vue'
import StoreSubHeader from '@/components/StoreSubHeader.vue'
import GroupSubHeader from '@/components/GroupSubHeader.vue'

import SnackBar from '@/components/SnackBar.vue'

const QRScanner = () => import(/* webpackChunkName: "qr-scanner" */ '@/components/QRScanner.vue')
const MenuItemConfig = () => import(/* webpackChunkName: "menu-item-config" */ '@/components/MenuItem/MenuItemConfigPages.vue')
const CouponConfig = () => import(/* webpackChunkName: "coupon-config" */ '@/components/Coupons/CouponConfig.vue')
const RewardsOptionsConfig = () => import(/* webpackChunkName: "rewards-config" */ '@/components/RewardsOptions/RewardsOptionConfig.vue')
const ManualTableNo = () => import(/* webpackChunkName: "manual-table" */ '@/components/Common/ManualTableNo')
const SuccessfulOrderDialog = () => import(/* webpackChunkName: "success-dialog" */ '@/components/Dialogs/SuccessfulOrderDialog')
const ContactTracingDialog = () => import(/* webpackChunkName: "contact-tracing" */ '@/components/Dialogs/ContactTracingDialog')
const ErrorMessageDialog = () => import(/* webpackChunkName: "error-dialog" */ '@/components/Dialogs/ErrorMessageDialog')
const OrderBonus = () => import(/* webpackChunkName: "order-bonus" */ '@/components/OrderBonus')
const iFrameDialog = () => import(/* webpackChunkName: "iframe-dialog" */ '@/components/Dialogs/iFrameDialog')
const LoginDialog = () => import(/* webpackChunkName: "login-dialog" */ '@/components/Auth/LoginDialog')
const GroupOrderJoinDialog = () => import(/* webpackChunkName: "group-order-join" */ '@/components/GroupOrder/GroupOrderJoinDialog')
const StoreFooter = () => import(/* webpackChunkName: "store-footer" */ '@/components/StoreFooter')
const DeliveryDialog = () => import(/* webpackChunkName: "delivery-dialog" */ './components/Dialogs/DeliveryDialog.vue')
const PickupDeliveryEditDialog = () => import(/* webpackChunkName: "pickup-dialog" */ './components/Dialogs/PickupDeliveryEditDialog.vue')
const StoreFooterCustom = () => import(/* webpackChunkName: "store-footer" */ './components/StoreFooterCustom.vue')


export default {
  name: 'App',

  components: {
    SuccessfulOrderDialog,
    ContactTracingDialog,
    ErrorMessageDialog,
    DeliveryDialog,
    PickupDeliveryEditDialog,
    OrderBonus,
    HeaderBar,
    HeaderBarCustom,
    StoreSubHeader,
    GroupSubHeader,
    SnackBar,
    QRScanner,
    MenuItemConfig,
    CouponConfig,
    RewardsOptionsConfig,
    ManualTableNo,
    LoginDialog,
    GroupOrderJoinDialog,
    iFrameDialog,
    StoreFooter,
    StoreFooterCustom
  },

  data() {
    return {
      showBackToTop: false,
      showRemovedFromGroupDialog: false,
      showLeftGroupDialog: false,
      showRecoveredGroupDialog: false,
      recoveredGroupName: '',
      recoveredGroupRole: '',
      showCancelledByHostDialog: false,
      showGroupOrderPaidDialog: false,
      showGroupChangedDialog: false,
      showSharedCartCompletedDialog: false,
      showSharedCartBillAtPosDialog: false,
      showSharedCartCancelledDialog: false,
      showSharedCartJoinedDialog: false,
    };
  },

  computed: {
    // shouldUseCustomHeader() {
    //   const pizzaDepotIdTest = 'G4520_test';
    //   const pizzaDepotId = 'G4520';
    //   return (this.getStore && this.getStore.groupId && (this.getStore.groupId == pizzaDepotId || this.getStore.groupId == pizzaDepotIdTest)) || (this.getGroup && (this.getGroup.groupId === pizzaDepotIdTest || this.getGroup.groupId === pizzaDepotId)) || (this.getStore && this.getStore.storeId === pizzaDepotIdTest || this.getStore.storeId === pizzaDepotId);
    // },
    ...mapGetters([
      'isMobile',
      'getStore',
      'getGroup',
      'isStoreLoading',
      'isLoading',
      'isLoggedIn',
      'getAuthToken',
      'getWeChatDialog',
      'isLocationDisabled',
      'showInStoreDlg',
      'getStripeInfo',
      'getStore',
      'getStateOrderTypes',
      'getOrderType',
      'shouldUseCustomHeader',
      'getQrScannerDialog'
    ]),
    groupChangedNotification() {
      return this.$store.state.groupOrder.groupChangedNotification
    },
    isSharedCartActive() {
      return this.$store.getters['sharedCart/isActive']
    },
  },

  methods: {
    dismissSharedCartCompletedDialog() {
      this.showSharedCartCompletedDialog = false;
      // The table's shared-cart session is over -- shared-cart Vuex state and localStorage
      // are already cleared (clearSharedCart, dispatched before this dialog ever showed).
      // A guest on a table URL stays dine-in at that table; anyone else returns to the
      // regular OWA flow -- see returnToRegularOwaAfterSharedCart.
      this.returnToRegularOwaAfterSharedCart();
    },
    async returnToRegularOwaAfterSharedCart() {
      // DEV-11506: the table's session ending doesn't mean the guest left the table. On a
      // table URL (tid/dineInOnly) stay DINE_IN -- forcing PICKUP here is what sent the
      // guest's next order to POS as a pickup. The refetch opens a fresh session for the
      // table (backend getOrCreate only reuses ACTIVE sessions, never the finished one).
      if (await this.$store.dispatch('enforceTableOrderType')) {
        this.$store.dispatch('fetchShoppingCart');
        return;
      }
      // No table in the URL (e.g. joined via an ?sc= invite link): nothing left to be
      // dine-in at, so fall back to the regular OWA flow.
      if (this.$route.name !== 'store') return;
      // Reset table/order-type state BEFORE navigating -- router.js's beforeEnter guard
      // and the global guard both re-run for this query-only replace (Vue Router 3 treats
      // a changed query as a new navigation) and dispatch their own ensureStoreCart/
      // fetchShoppingCart off whatever state exists at that moment. Committing first means
      // those fetches see the already-corrected (non-dine-in) state instead of racing it.
      this.$store.commit('CLEAR_TABLE_ID');
      // setOrderTypeIfNotSet only fills in a default when the current type is empty/
      // invalid -- DINE_IN is a normally-valid storeOrderTypes entry, so it would never
      // trigger here. This table's dine-in session is over; force PICKUP (falling back to
      // the store's first supported type), same preference setOrderTypeIfNotSet itself uses.
      const storeOrderTypes = this.$store.getters.getStoreOrderTypes || [];
      const pickupType = storeOrderTypes.find((type) => type.value === 'PICKUP');
      const nextType = pickupType || storeOrderTypes[0];
      if (nextType) {
        this.$store.dispatch('setOrderType', nextType.value);
      }
      const { dineInOnly, tid, skipBeforeEnter, ...restQuery } = this.$route.query;
      this.$router.replace({ name: 'store', params: this.$route.params, query: restQuery }).catch((err) => {
        if (err && err.name !== 'NavigationDuplicated') console.error('[SharedCart] Failed to leave dine-in mode:', err);
      });
    },
    dismissGroupOrderPaidDialog() {
      this.showGroupOrderPaidDialog = false;
      this.$store.dispatch('groupOrder/disconnectWs');
      this.$store.commit('groupOrder/RESET_GROUP_ORDER');
    },
    dismissRemovedDialog() {
      this.showRemovedFromGroupDialog = false;
      this.$store.commit('groupOrder/RESET_GROUP_ORDER');
    },
    dismissCancelledDialog() {
      this.showCancelledByHostDialog = false;
      this.$store.commit('groupOrder/RESET_GROUP_ORDER');
    },
    dismissSharedCartCancelledDialog() {
      this.showSharedCartCancelledDialog = false;
      this.$store.commit('sharedCart/SET_CANCELLED', false);
    },
    dismissGroupChangedDialog() {
      this.showGroupChangedDialog = false;
      this.$store.commit('groupOrder/SET_GROUP_CHANGED_NOTIFICATION', null);
    },
    formatGroupOrderTime(isoString) {
      if (!isoString || isoString === 'now') return this.$vuetify.t('$vuetify.groupOrder.asap');
      try {
        const d = new Date(isoString);
        if (isNaN(d.getTime())) return isoString;
        const tz = (this.$store.getters.getStore && this.$store.getters.getStore.timeZone) || 'America/Toronto';
        return d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true, timeZone: tz });
      } catch (e) {
        return isoString;
      }
    },
    formatGroupOrderAddress,
    initializeTrackingCodes() {
      if (window.initializeSocialMediaTracking && this.getStore) {
        window.initializeSocialMediaTracking(get(this.getStore, 'settings', {}));
      }
    },

    // Moved here from SuccessfulOrderDialog.vue (DEV-10864): that component is async-
    // loaded (a separate JS chunk) and only mounts once its own <successful-order-dialog>
    // tag renders inside App.vue's tree -- so on a slow connection, or if that chunk simply
    // hadn't finished loading yet, the GTM container never injected at all on pages before
    // checkout, matching Vegholic's report of it "not detected even on the homepage" and
    // "not firing consistently... beyond just the checkout/order confirmation flow".
    // Triggering it from App.vue's own root-level, immediate getStore watcher instead means
    // it fires as early as the store's settings are known, on every route, not only once a
    // lazy dialog component happens to have mounted.
    //
    // Idempotent by construction (see below): safe to call on every getStore change,
    // including the same store re-firing or switching to a different store's tag.
    initializeGTM() {
      const gtmTag = get(this.getStore, 'settings.owaSettings.thirdPartyTrackingCode', '');
      if (gtmTag) {
        // Removes any previously-injected gtm.js script that ISN'T gtag/js and isn't
        // already the current tag -- handles switching between two stores (different GTM
        // IDs) in the same session without leaving the old store's container active.
        const gtmScripts = document.querySelectorAll(`script[src*="googletagmanager.com/gtm.js"]`);
        gtmScripts.forEach(script => {
          if (!script.src.includes('gtag/js')) {
            script.parentNode.removeChild(script);
          }
        });

        const gtmScriptExists = !!document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmTag}"]`);
        if (!gtmScriptExists) {
          (function(w,d,s,l,i){
            w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
            var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer', gtmTag);

          const noscript = document.createElement('noscript');
          noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmTag}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
          document.body.appendChild(noscript);

          console.log('GTM initialized:', gtmTag);
        } else {
          console.log('GTM script already loaded.');
        }
      }
    },

    handleQRInput(result) {
      if (result) {
        this.closeWeChatDialog()
      }
    },

    closeInStoreDlg () {
      if (location) {
        this.setInStore({
            location: false,
            inStore: false,
            inStoreDlg: false
        })
      } else {
        this.setInStore({
            location: false,
            inStore: false,
            inStoreDlg: false
        })
      }
    },

    removeParam(key) {
      let query = Object.assign({}, this.$route.query);
      delete query[key];
      this.$router.replace({ query }).catch(() => {})
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    handleScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        this.showBackToTop = scrollTop > 200;
        this.updateExternalButton();
      });
    },

    createExternalButton() {
      const existingBtn = document.getElementById('external-back-to-top-btn');
      if (existingBtn) {
        existingBtn.remove();
      }
      // Remove circular scroll-to-top button on mobile devices
      // The square jump-to-menu button in MenuCategory.vue provides this functionality
      return;
      const button = document.createElement('div');
      button.id = 'external-back-to-top-btn';
      button.innerHTML = '↑';
      
      button.style.cssText = `
        position: fixed !important;
        bottom: 20px !important;
        right: 16px !important;
        width: 56px !important;
        height: 56px !important;
        border-radius: 50% !important;
        background-color: var(--v-primary-base, #B51299) !important;
        color: white !important;
        cursor: pointer !important;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        font-size: 24px !important;
        font-weight: bold !important;
        font-family: Arial, sans-serif !important;
        user-select: none !important;
        -webkit-user-select: none !important;
        z-index: 2147483647 !important;
        opacity: 0 !important;
        visibility: hidden !important;
        transition: opacity 0.3s ease, visibility 0.3s ease !important;
        
        /* Nuclear option: break ALL possible stacking contexts */
        isolation: isolate !important;
        transform: translateZ(0) translate3d(0,0,0) !important;
        will-change: transform !important;
        contain: layout style paint !important;
        filter: none !important;
        perspective: none !important;
        clip-path: none !important;
        mask: none !important;
        mix-blend-mode: normal !important;
        backdrop-filter: none !important;
        backface-visibility: hidden !important;
        -webkit-backface-visibility: hidden !important;
        transform-style: flat !important;
        -webkit-transform-style: flat !important;
        
        /* Force layer creation */
        -webkit-transform: translateZ(0) translate3d(0,0,0) !important;
        -moz-transform: translateZ(0) translate3d(0,0,0) !important;
        -ms-transform: translateZ(0) translate3d(0,0,0) !important;
        -o-transform: translateZ(0) translate3d(0,0,0) !important;
      `;
      button.addEventListener('click', this.scrollToTop);
      document.body.appendChild(button);
      
      console.log('External button created and appended to body');
    },

    updateExternalButton() {
      const button = document.getElementById('external-back-to-top-btn');
      if (!button) return;

      const shouldShow = this.$vuetify.breakpoint.mdAndDown && this.showBackToTop;
      
      if (shouldShow) {
        button.style.setProperty('visibility', 'visible', 'important');
        button.style.setProperty('opacity', '1', 'important');
      } else {
        button.style.setProperty('visibility', 'hidden', 'important');
        button.style.setProperty('opacity', '0', 'important');
      }
    },

    handleResize() {
      this.createExternalButton();
    },
    fetchOrderType() {
      // Allow a query paramater to set the default order type
      const orderType = get(this.$router, 'history.current.query.orderType', '').toUpperCase()
      const existingMode = ['PICKUP', 'DELIVERY', 'DINE_IN'].find(mode => mode == orderType)
      let query = Object.assign({}, this.$route.query);

      if (!!existingMode) {
        this.setOrderType(orderType)

        if (orderType == 'DINE_IN')
          this.SET_ENTERED_VIA_QR(true)

        // Remove the orderType from the url query
        this.removeParam('orderType')
      }
    },
    saveUtmParameters() {
      const urlParams = new URLSearchParams(window.location.search);
      const utmSource = urlParams.get('utm_source');
      const utmMedium = urlParams.get('utm_medium');
      const utmCampaign = urlParams.get('utm_campaign');
      const utmTerm = urlParams.get('utm_term');
      const utmContent = urlParams.get('utm_content');

      if (utmSource) {
        try {
          const timestamp = Date.now();
          localStorage.setItem('utm_source', utmSource);
          localStorage.setItem('utm_timestamp', timestamp.toString());
          if (utmMedium) localStorage.setItem('utm_medium', utmMedium);
          if (utmCampaign) localStorage.setItem('utm_campaign', utmCampaign);
          if (utmTerm) localStorage.setItem('utm_term', utmTerm);
          if (utmContent) localStorage.setItem('utm_content', utmContent);
        } catch (e) {
          console.error('Error saving UTM parameters:', e);
        }
      }
    },
    fetchPixelCode() {
      const urlParams = new URLSearchParams(window.location.search)
      const urlPixelCode = urlParams.get('PixelCode')

      const trackingCodes = get(this.getStore, 'settings.owaSettings.socialMediaTrackingCode', [])
      const metaEntry = trackingCodes.find(t => t.type === 'META')
      const storePixelCode = metaEntry && metaEntry.value

      const PixelCode = urlPixelCode || storePixelCode

      if (!PixelCode) return
      if (window._fbPixelInitialized) return
      window._fbPixelInitialized = true

      // Set up fbq queue before script loads
      window.fbq = window.fbq || function() {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments)
      }
      if (!window._fbq) window._fbq = window.fbq
      window.fbq.push = window.fbq
      window.fbq.loaded = true
      window.fbq.version = '2.0'
      window.fbq.queue = window.fbq.queue || []

      // Inject script tag into <head> so Meta Pixel Helper can detect it
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)

      fbq('init', PixelCode)
      fbq('track', 'PageView')

      if (urlPixelCode) this.removeParam('PixelCode')
    },
    fetchTikTokPixelCode() {
      const urlParams = new URLSearchParams(window.location.search)
      const urlPixelCode = urlParams.get('TikTokPixelCode')

      const trackingCodes = get(this.getStore, 'settings.owaSettings.socialMediaTrackingCode', [])
      const tiktokEntry = trackingCodes.find(t => t.type === 'TIKTOK')
      const storePixelCode = tiktokEntry && tiktokEntry.value

      const PixelCode = urlPixelCode || storePixelCode

      if (!PixelCode) return
      if (window._ttPixelInitialized) return
      window._ttPixelInitialized = true

      // Official TikTok Pixel base code (ttq stub/queue), per
      // https://ads.tiktok.com/help/article/get-started-pixel
      !function (w, d, t) {
        w.TiktokAnalyticsObject = t
        var ttq = w[t] = w[t] || []
        ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie']
        ttq.setAndDefer = function(t, e) {
          t[e] = function() {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
          }
        }
        for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i])
        ttq.instance = function(t) {
          var e = ttq._i[t] || []
          for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n])
          return e
        }
        ttq.load = function(e, n) {
          var i = 'https://analytics.tiktok.com/i18n/pixel/events.js'
          ttq._i = ttq._i || {}
          ttq._i[e] = []
          ttq._i[e]._u = i
          ttq._t = ttq._t || {}
          ttq._t[e] = +new Date()
          ttq._o = ttq._o || {}
          ttq._o[e] = n || {}
          var o = document.createElement('script')
          o.type = 'text/javascript'
          o.async = true
          o.src = i + '?sdkid=' + e + '&lib=' + t
          var a = document.getElementsByTagName('script')[0]
          a.parentNode.insertBefore(o, a)
        }
        ttq.load(PixelCode)
        ttq.page()
      }(window, document, 'ttq')

      if (urlPixelCode) this.removeParam('TikTokPixelCode')
    },

    ...mapActions(['closeWeChatDialog', 'setInStore', 'showSnack', 'setSuccessfulOrderDialog', 'resetCart', 'setOrderType', 'clearCheckoutInfo', 'lookForOrderRewards', 'setDeliveryAddress']),
    ...mapMutations([ 'setLoginDialog', 'setAuthUser', 'SET_IFRAME', 'SET_STRIPE_INFO', 'GENERATE_ORDER_UUID', 'SET_PAYMENT_TYPE', 'SET_DIALOG_MESSAGE', 'SET_KIOSK_MODE', 'SET_ENTERED_VIA_QR', 'SET_ORDER_TYPE', 'SET_CHECKOUT_INFO' ])
  },

  watch: {
    '$store.state.groupOrder.recoveredSession': function(session) {
      if (session) {
        this.recoveredGroupName = session.groupName || 'Group Order'
        this.recoveredGroupRole = session.isHost ? this.$vuetify.t('$vuetify.groupOrder.dialogRecoveredHost') : this.$vuetify.t('$vuetify.groupOrder.dialogRecoveredGuest')
        this.showRecoveredGroupDialog = true
        this.$store.commit('groupOrder/SET_RECOVERED_SESSION', null)
      }
    },
    '$store.state.groupOrder.checkoutStatus': function(status) {
      if (status === 'paid' && !this.$store.state.groupOrder.isHost) {
        this.showGroupOrderPaidDialog = true;
      }
    },
    '$store.state.groupOrder.removed': function(removed) {
      if (removed) {
        this.showRemovedFromGroupDialog = true;
      }
    },
    '$store.state.groupOrder.left': function(left) {
      if (left) {
        this.showLeftGroupDialog = true;
      }
    },
    '$store.state.groupOrder.cancelled': function(cancelled) {
      if (cancelled) {
        this.showCancelledByHostDialog = true;
      }
    },
    '$store.state.sharedCart.justJoined': function(justJoined) {
      if (justJoined) {
        this.showSharedCartJoinedDialog = true;
        this.$store.commit('sharedCart/SET_JUST_JOINED', false);
      }
    },
    '$store.state.sharedCart.sessionClosedNotice': function(notice) {
      // Set when a refetch/mutation discovers — via order.orderStatus, no live
      // WS event involved — that this session had already ended before we got
      // here (e.g. loading a stale ?sc= invite link, or reloading the page
      // after the table was closed on another device). Survives clearSharedCart's
      // reset so this watcher can still see it; clear it back to null ourselves
      // once handled so it doesn't refire.
      if (notice) {
        this.showSharedCartBillAtPosDialog = notice.orderStatus === 'PAY_REQUEST';
        this.showSharedCartCompletedDialog = notice.orderStatus === 'PAID' || notice.orderStatus === 'COMPLETED';
        // Any other/unrecognized terminal orderStatus still means the session
        // is over and this guest's cart is gone — fall back to the cancelled
        // dialog rather than silently showing nothing, which previously left
        // the guest with no explanation at all.
        if (!this.showSharedCartBillAtPosDialog && !this.showSharedCartCompletedDialog) {
          this.showSharedCartCancelledDialog = true;
        }
        // Strip ?sc= via the raw History API, NOT $router.replace: this route's
        // beforeEnter guard treats menu-selection -> menu-selection (same sid)
        // as a fresh navigation and remounts MenuSelectionPage, which re-runs
        // its entire bootstrap (fetchStore, fetchLiteMenus, fetchShoppingCart,
        // fetchFullMenuDetails...) — a burst of dozens of duplicate requests
        // just to clean up a query param. history.replaceState changes the
        // visible URL without touching the router's navigation pipeline at all.
        if (window.location.search.indexOf('sc=') !== -1) {
          var urlParams = new URLSearchParams(window.location.search);
          urlParams.delete('sc');
          urlParams.delete('sharedCartSessionId');
          var newSearch = urlParams.toString();
          var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
          window.history.replaceState(window.history.state, '', newUrl);
        }
        this.$store.commit('sharedCart/SET_SESSION_CLOSED_NOTICE', null);
      }
    },
    '$store.state.sharedCart.status': function(status) {
      if (status === 'COMPLETED') {
        // The shared-cart session reaching COMPLETED does not always mean the
        // bill was actually paid — for stores using "pay at POS", finalize
        // sends the bill to the terminal and the order stays at PAY_REQUEST
        // until staff process payment in person.
        var orderStatus = this.$store.state.sharedCart.order && this.$store.state.sharedCart.order.orderStatus;
        this.showSharedCartBillAtPosDialog = orderStatus === 'PAY_REQUEST';
        this.showSharedCartCompletedDialog = !this.showSharedCartBillAtPosDialog;
      }
    },
    '$store.state.sharedCart.cancelled': function(cancelled) {
      if (cancelled) {
        this.showSharedCartCancelledDialog = true;
      }
    },
    '$store.state.groupOrder.groupChangedNotification': function(notification) {
      if (notification && !notification.pending) {
        const hasChange = (notification.oldOrderType !== notification.newOrderType)
          || (notification.oldScheduledTime !== notification.newScheduledTime)
          || (JSON.stringify(notification.oldDeliveryAddress) !== JSON.stringify(notification.newDeliveryAddress));
        if (hasChange) {
          this.showGroupChangedDialog = false;
          this.$nextTick(() => { this.showGroupChangedDialog = true; });
        }
      }
    },
    '$store.state.checkout.checkoutInfo.scheduledTime': function(val) {
      if (!this.$store.getters['groupOrder/isInGroupOrder']) return;
      try {
        if (val) window.localStorage.setItem('go_scheduledTime', val);
        else window.localStorage.removeItem('go_scheduledTime');
      } catch (e) {}
      // Suppressed while DeliveryDialog is open mid-switch (its selects write straight to
      // checkoutInfo with no draft-staging) or right after commitGroupOrderTypeSwitch's own
      // applyGroupSettingsToCart sync -- neither is a fresh, already-unrelated host edit
      // that this watcher should independently re-send.
      if (isScheduledTimeWatcherSuppressed()) return;
      if (this.$store.state.groupOrder.isHost && val) {
        // Skip if this value is already what the server has — it means applyGroupSettingsToCart
        // just synced from the server (restore/refresh), not a host-initiated change.
        // Compare by UTC ms to handle both ISO strings and locally-encoded Date objects.
        var serverScheduledTime = this.$store.state.groupOrder.group && this.$store.state.groupOrder.group.scheduledTime;
        var valMs = (val && val !== 'now') ? new Date(val).getTime() : null;
        var serverMs = serverScheduledTime ? new Date(serverScheduledTime).getTime() : null;
        if (valMs === serverMs) return;
        // Only send if val looks like a true UTC ISO (from applyGroupSettingsToCart or server),
        // not a locally-encoded Date object that needs moment.tz reinterpretation.
        // PickupDeliveryEditDialog handles the group order update directly, so skip here.
        if (val instanceof Date || (typeof val === 'object' && val !== null)) return;
        this._debouncedUpdateScheduledTime(val);
      }
    },
    '$store.state.checkout.checkoutInfo.scheduledDay': function(val) {
      if (!this.$store.getters['groupOrder/isInGroupOrder']) return;
      try {
        if (val) window.localStorage.setItem('go_scheduledDay', val);
        else window.localStorage.removeItem('go_scheduledDay');
      } catch (e) {}
    },
     getStore: {
      handler(newStore, oldStore) {
        if (newStore && newStore.storeId && (!oldStore || !oldStore.storeId)) {
          this.fetchPixelCode()
          this.fetchTikTokPixelCode()
        }
        // Every newStore with a value, not just the empty->populated transition above --
        // initializeGTM() is idempotent (swaps the script if the tag changed, no-ops if
        // it's already the current tag) so this safely re-runs on a store switch too.
        if (newStore) {
          this.initializeGTM();
        }
        const pizzaDepotIdTest = 'G4520_test';
        const pizzaDepotId = 'G4520';

        const useCustomHeader = (newStore && newStore.groupId &&
          (newStore.groupId == pizzaDepotId || newStore.groupId == pizzaDepotIdTest)) ||
          (this.getGroup && (this.getGroup.groupId === pizzaDepotIdTest || this.getGroup.groupId === pizzaDepotId)) ||
          (newStore && (newStore.storeId === pizzaDepotIdTest || newStore.storeId === pizzaDepotId));

        this.$store.dispatch('setCustomHeader', useCustomHeader);
        const currentStoreId = (newStore && newStore.storeId) || this.$route.params.sid || (this.$route.query && this.$route.query.storeId) || null;
        const lastStoreId = localStorage.getItem('lastStoreId');
        const isSkippingReload = sessionStorage.getItem('skipStoreReload') === 'true';
        const isDirectNavigationFromGroup = isSkippingReload;
        if (currentStoreId && lastStoreId && currentStoreId !== lastStoreId && !isDirectNavigationFromGroup) {
          try {
            let authData = null;
            try {
              const vuexData = localStorage.getItem('vuex');
              if (vuexData) {
                const parsedData = JSON.parse(vuexData);
                if (parsedData && parsedData.auth) {
                  authData = { auth: parsedData.auth };
                }
              }
            } catch (authErr) {
              console.error('Error preserving auth data', authErr);
            }
            
            // clearing only app-specific localStorage keys instead of clearing all
            try {
              for (const key of APP_SPECIFIC_KEYS) {
                localStorage.removeItem(key);
              }
            } catch (e) {
              console.error('Error clearing app-specific localStorage keys', e);
            }
            
            try { sessionStorage.clear(); } catch (e) {}
            if (authData) {
              try {
                localStorage.setItem('vuex', JSON.stringify(authData));
              } catch (e) {
                console.error('Error restoring auth data', e);
              }
            }
            try { localStorage.setItem('lastStoreId', currentStoreId); } catch (e) {}
              const storeLangs = (newStore && newStore.languages) || [];
              let currentLang = this.$vuetify.lang.current;
              if (storeLangs.length > 0 && !storeLangs.find(l => l.code === currentLang)) {
                const defaultLang = storeLangs.find(l => l.selected) || storeLangs[0];
                if (defaultLang && defaultLang.code) {
                  this.$vuetify.lang.current = defaultLang.code;
                  if (this.$i18nPointer) this.$i18nPointer.locale = defaultLang.code;
                  localStorage.setItem('lang', defaultLang.code);
                }
              }
            this.resetCart();
            this.setDeliveryAddress(null);
            this.$store.commit('SET_ORDER_TYPE', ''); 
            this.$store.commit('SET_CHECKOUT_INFO', {});
            try {
              if (window.indexedDB && indexedDB.databases) {
                indexedDB.databases().then(dbs => {
                  dbs.forEach(db => {
                    try { indexedDB.deleteDatabase(db.name); } catch (e) {}
                  });
                });
              }
            } catch (e) {}
            
            try {
              if ('caches' in window) {
                caches.keys().then(names => {
                  for (let name of names) {
                    try { caches.delete(name); } catch (e) {}
                  }
                });
              }
            } catch (e) {}
            
            try {
              document.cookie.split(";").forEach(cookie => {
                const eqPos = cookie.indexOf("=");
                const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
              });
            } catch (e) {}
            
            window.location.reload();
          } catch (e) {
            console.error('Error in store switch cleanup', e);
          }
        } else if (currentStoreId && lastStoreId && currentStoreId !== lastStoreId && isDirectNavigationFromGroup) {
          localStorage.setItem('lastStoreId', currentStoreId);
        } else if (currentStoreId && !lastStoreId) {
          localStorage.setItem('lastStoreId', currentStoreId);
        }
      },
      immediate: true 
    },
    isLoading() {
      // Gross timeout since the query for whatever reason isn't available instantly
      setTimeout(() => {
        this.saveUtmParameters()
        this.fetchOrderType()
        this.fetchPixelCode()
        this.fetchTikTokPixelCode()

        const kioskMode = getUrlParameter('kioskMode')
        if (kioskMode != null && kioskMode != '') {
          this.SET_KIOSK_MODE(kioskMode == true || kioskMode == 'true')
          this.removeParam('kioskMode')
        }

        // If the current orderType is not currently supported, switch to the first option
        if (!isNullOrEmpty(this.getStateOrderTypes)) {
          if (this.getStateOrderTypes.findIndex(_orderType => _orderType.value == this.getOrderType) == -1)
            this.setOrderType(this.getStateOrderTypes[0].value)
        } else {
          this.showSnack('No OrderTypes enabled')
        }
      }, 3000)
    }
  },
  created() {
    this._debouncedUpdateScheduledTime = debounce((val) => {
      this.$store.dispatch('groupOrder/updateScheduledTime', { scheduledTime: val }).catch(function() {});
    }, 300);

    // Restore shared cart session (dine-in table) as early as possible — before
    // route components mount and run their own cart-fetch logic, which would
    // otherwise race restoreSession and fetch a normal (non-shared) cart first.
    var _scStore = this.$store
    var _scVue = this
    this.$store.dispatch('sharedCart/restoreSession', {}).then(function(restored) {
      if (restored) {
        _scStore.dispatch('showSnack', {
          // DEV-11545: the table's name (B1), like the cart banner, not its id (4)
          // a function so it follows the store's language once applied (QA-4631)
          text: function() { return _scVue.$vuetify.t('$vuetify.sharedCart.reconnected', [_scStore.getters['sharedCart/tableLabel']]) },
          color: 'primary',
          timeout: 3000
        })
      }
    }).catch(function() {})
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    this.$nextTick(() => {
      this.createExternalButton();
    });

    // Restore group order session after page refresh and reconnect WebSocket
    var _router = this.$router
    var _vuexStore = this.$store
    this.$store.dispatch('groupOrder/restoreSession', {
      onGroupPaid: function() {
        // Dialog is shown via the checkoutStatus watcher above
      },
      onRemoved: function() {
        _router.push({ name: 'store' }).catch(function() {})
        // TODO: navigate to group order removed page once it exists
      },
      onCountdownLocked: function() {
        // Cart.vue watches groupOrder/myCartLocked and will disable editing
      },
    }).then(function(restored) {
      // Re-apply group settings after restoreSession in case fetchShoppingCart
      // ran concurrently and cleared scheduledTime via an error handler
      if (restored && _vuexStore.getters['groupOrder/isInGroupOrder']) {
        _vuexStore.dispatch('groupOrder/reapplyGroupSettings')
      }
      // Guard: delivery with no address is invalid — fall back to pickup
      if (_vuexStore.state.cart.orderType === 'DELIVERY' && !_vuexStore.state.cart.deliveryAddress) {
        _vuexStore.commit('SET_ORDER_TYPE', 'PICKUP')
      }
    }).catch(function() {})

    let _this = this

    const pizzaDepotIdTest = 'G4520_test';
    const pizzaDepotId = 'G4520';
  
    const useCustomHeader = (this.getStore && this.getStore.groupId && 
      (this.getStore.groupId == pizzaDepotId || this.getStore.groupId == pizzaDepotIdTest)) || 
      (this.getGroup && (this.getGroup.groupId === pizzaDepotIdTest || this.getGroup.groupId === pizzaDepotId)) || 
      (this.getStore && (this.getStore.storeId === pizzaDepotIdTest || this.getStore.storeId === pizzaDepotId));
    
    this.$store.dispatch('setCustomHeader', useCustomHeader);

    if (this.getStore) {
      this.initializeTrackingCodes();
    }

    this.$watch('getStore', (newStore) => {
      if (newStore) {
        this.initializeTrackingCodes();
      }
    });

    const isStripeStore = () => {
      return get(this.getStore, 'settings.paymentProvider') == 'STRIPE'
    }

    // If the user logged in on lottery but it doesn't match the authToken in this state, copy that token
    const _store = JSON.parse(localStorage.getItem('featureState') || '{}')
    const authUser = get(_store, 'user')

    if (authUser && authUser.authToken && !this.getAuthToken)
      this.setAuthUser({ user: authUser, authToken: authUser.authToken })

    function onGlobalPayments3DS(orderId) {
      // Pull the information out and always reset ids
      const { paymentReq, paymentResp } = {..._this.getStripeInfo}

      _this.SET_STRIPE_INFO(null)

      _this.$api.get(`/payment/${orderId}`).then(res => {
        const { status } = res.data

        if (status == 'AUTH_REQUEST' || status == 'AUTH_FAILED' || status == 'CHARGE_REQUEST' || status == 'CHARGE_FAILED') {
          _this.$api.post('/order/error', {
            error: 'Global Payment 3DS Failure. Status: '+status,
            statusCode: -1,
            storeId: get(_this.getStore, 'storeId', 0)
          })

          _this.SET_DIALOG_MESSAGE({
            title: "Error Occured",
            body: 'Authorization for your payment failed',
            message: 'Please, try again'
          })
        } else {
          _this.setSuccessfulOrderDialog({
            ...paymentReq,
            ...paymentResp
          })

          _this.lookForOrderRewards(paymentResp)
        }
      }).catch(error => {
        this.$api.post('/order/error', {
          error: ''+findErrorMessage(error) || `global: /payment/${orderId} failed`,
          statusCode: get(error, 'response.status', -1),
          storeId: get(_this.getStore, 'storeId', 0)
        })
      })
    }

    window.top.addEventListener('message', function(ev) {
      if (!isStripeStore() && ev.data.message == '3DS-GLOBALPAYMENTS-authentication-complete') {
        _this.SET_IFRAME(null)

        onGlobalPayments3DS(ev.data.payload);
      }
    }, false);
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    const button = document.getElementById('external-back-to-top-btn');
    if (button) {
      button.remove();
    }
    
    window.top.removeEventListener('message', () => {})
  }
}
</script>

<style>
  #app {
    padding-top: 49px;
  }
  .mobile-toolbar-header #app, 
  .app.mobile-toolbar-header {
    background-color: #F3F1EA;
    font-family: Arial, Helvetica, sans-serif !important; 
    padding-top: 37px !important;
  }
  :root {
    --text: #2c3e50;
    --danger: #f0506e;
    --v-error-base: #f0506e !important;

    --text-size-sub: 0.9rem;
    --text-size-1: 1rem;
    --text-size-2: calc(var(--text-size-1) * 1.6);
    --text-size-3: calc(var(--text-size-2) * 1.6);
    --text-size-4: calc(var(--text-size-3) * 1.6);

    --card-border-color: rgba(120, 120, 120, .15);
    --card-border: 1px solid var(--card-border-color);
    --card-border-radius: 5px;
    --hover-colour: rgba(0, 0, 0, 0.04);
  }

  .header-custom, .mobile-toolbar-header {
    --container-max-width: 1140px;
    --content-width: min(100%, var(--container-max-width));
  }
  
  .white-header {
    --content-width: 100%;
  }

  @font-face {
    /* !important has no meaning inside @font-face and was getting the whole
       font-family declaration stripped at build time -- this face never
       actually registered, so #app's "Poppins" fell back silently to
       Helvetica/Arial everywhere. index.html now also loads Poppins from
       Google Fonts (same source reservation's shared header uses) as the
       primary source; this local face stays as an offline/CDN-down fallback. */
    font-family: "Poppins";
    src: local("Poppins"), url(./fonts/Poppins-Regular.ttf) format("truetype");
  }

  #app {
    font-family: "Poppins", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: var(--text);
  }

  .text-size-sub { font-size: var(--text-size-sub); }
  .text-size-1 { font-size: var(--text-size-1); }
  .text-size-2 { font-size: var(--text-size-2); }
  .text-size-3 { font-size: var(--text-size-3); }
  .text-size-4 { font-size: var(--text-size-4); }

  .hover-animation-container { padding: 2.5px; }
  .hover-animation-container .v-card,
  .hover-animation-container .CardContainer,
  .hover-animation-container .hover-target {
    position: relative;
    top: 0px;
    transition: all .12s ease-in-out;
    border: var(--card-border) !important;
    border-radius: var(--card-border-radius);
  }
  .hover-animation-container:not(.out-of-stock):not(.disabled) .v-card:hover,
  .hover-animation-container:not(.out-of-stock) .CardContainer:hover,
  .hover-animation-container:not(.disabled) .hover-target:hover {
    top: -5px !important;
    box-shadow: 0 0 11px rgba(33,33,33,.2) !important;
  }

  .menu-config-dialog.v-dialog:not(.v-dialog--fullscreen) { margin: 0 24px; }
  .menu-item-config .v-dialog > .v-card > .v-toolbar {
    position: sticky;
    top: 0;
    z-index: 999;
  }

  #nav { padding: 30px; }
  #nav a {
    font-weight: bold;
    color: var(--text);
  }
  #nav a.router-link-exact-active { color: var(--v-primary-base, #202123) !important; }

  .pdt20 { padding: 20px 0px 0px 0px; }
  .mb10 { margin: 0px 0px 10px 0px; }
  .mt15 { margin: 15px 0px 0px 0px; }

  .errorStatus {
    font-size: 14px !important;
    text-align: center !important;
    color: #D8000C !important;
    margin-top: 5px !important;
  }
  .errorStatus .v-avatar {
    width: 15px !important;
    height: 15px !important;
  }

  .v-btn-toggle .v-btn { opacity: .65 !important; }
  .v-tabs .v-window__container { height: auto !important; }

  .pointer { cursor: pointer; }
  .clickable { cursor: pointer !important; }
  .fullHeight { height: 100% }
  .fullWidth { width: 100% }
  .header-custom {
    background-color: #F3F1EA;
    font-family: Arial, Helvetica, sans-serif !important; 
  }
  .white-header { background-color: #FFFFFF; }
  .noMargin { margin: 0px !important; }
  .center { margin: auto !important; }
  .noSelect {
    -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
  }

  .remove-shadow { box-shadow: none !important; }
  .snappy-box {
    border: var(--card-border) !important;
    border-radius: var(--card-border-radius);
  }
  .snappy-box-no-shadow {
    box-shadow: none !important;
    border: var(--card-border) !important;
    border-radius: var(--card-border-radius);
  }

  html {
    scroll-behavior: smooth;
    touch-action: manipulation;
  }
  .overflow-y-hidden { overflow-y: hidden !important; }

  #iFrameDialog, .iFrameDialog {
    max-height: 1000px; height: 90vh; overflow: hidden !important
  }

  .footer, #Footer, .store-footer, .store-footer-custom {
    width: 100% !important;
    max-width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .store-footer, #Footer:not(.store-footer-custom) {
    color: white !important; 
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  
  .footer-content-wrap {
    max-width: var(--content-width);
    margin-left: auto;
    margin-right: auto;
    padding-left: 30px;
    padding-right: 30px;
  }
  
  img, video, iframe { max-width: 100%; }
  
  * { box-sizing: border-box; }
  
  .v-content, .v-sheet, .container { max-width: 100%; }

  @media (max-width: 959px) {
    .v-content__wrap {
      padding-left: 0px;
      padding-right: 0px;
    }
    .footer-content-wrap {
      padding-left: 0px;
      padding-right: 0px;
    }
    .header-custom {
      --container-max-width: 1140px;
      --content-width: min(100%, var(--container-max-width));
    }
    
    .header-custom .v-content__wrap {
      max-width: var(--content-width);
      margin-left: auto;
      margin-right: auto;
      padding-left: 30px;
      padding-right: 30px;
    }
  }
  
  @media (min-width: 960px) {
    .header-custom .v-content__wrap {
      padding-left: 50px;
      padding-right: 50px;
    }
  }
  
  .v-toolbar, footer { width: 100% !important; }
  .application--wrap,
  .v-application--wrap,
  .v-content,
  .v-content__wrap,
  .header-custom .application--wrap,
  .header-custom .v-application--wrap,
  .header-custom .v-content,
  .header-custom .v-content__wrap {
    min-height: 0 !important;
    height: auto !important;
    max-height: none !important;
    overflow-y: visible !important;
    overflow-x: visible !important;
  }
  body {
    height: 100% !important;

  }
  html {
    margin: 0 !important;
    padding: 0 !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
  }

  #global-back-to-top-button {
    position: fixed !important;
    z-index: 9999 !important;
    transform: translateZ(0) !important;
    will-change: transform !important;
    contain: layout style paint !important;
    isolation: isolate !important;
  }
</style>